import React from 'react';

class ReactPolygonDrawer extends React.Component {
  state = {
    coordinates: [],
  };

  isDrawing = false;

  canvasRef = React.createRef();

  componentDidMount() {
    setTimeout(() => {
      this.addListeners();
    }, 400);
    this.clearCanvas();
    this.setDrawingFlag(true);
    this.drawfromPassedCoordinates();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  addListeners = () => {
    const {
      current,
    } = this.canvasRef;
    if (!current) return;
    current.addEventListener('click', this.onClick);
    current.addEventListener('mousemove', this.onMouseMove);
    current.addEventListener('dblclick', this.dblclick);
  };

  removeListeners = () => {
    const {
      current,
    } = this.canvasRef;
    if (!current) return;

    current.removeEventListener('click', this.onClick);
    current.removeEventListener('mousemove', this.onMouseMove);
    current.removeEventListener('dblclick', this.dblclick);
  };

  drawfromPassedCoordinates = () => {
    const { coordinates } = this.props;
    if (coordinates && coordinates.length) {
      this.setState({ coordinates }, this.drawCoordinates);
      this.setDrawingFlag(false);
    }
  };

  setDrawingFlag = flag => {
    this.isDrawing = flag;
  };

  clearCanvas = () => {
    const {
      width,
      height,
    } = this.props;
    const canvasContext = this.getCanvasContext();
    canvasContext.clearRect(0, 0, width, height);
  };

  getCanvasContext = () => {
    if (this.canvasRef.current) {
      const canvasContext = this.canvasRef.current.getContext('2d');
      return canvasContext;
    }
    return null;
  };

  dblclick = _ev => {
    const {
      coordinates,
    } = this.state;
    const { onFinish = () => {} } = this.props;

    const [{ x, y }] = coordinates;

    this.pushCoordinates(x, y);
    this.setDrawingFlag(false);
    this.drawCoordinates();
    const finalCoordinates = [
      ...coordinates,
    ];
    onFinish(finalCoordinates);
  };

  onClick = ev => {
    if (ev.detail === 2) return; // exclude dblclick
    if (!this.isDrawing) {
      this.setDrawingFlag(true);
      this.drawCoordinates();
      this.setState({
        coordinates: [],
      }, this.drawCoordinates);
    }

    const {
      offsetX,
      offsetY,
    } = ev;

    this.pushCoordinates(offsetX, offsetY);
    this.drawDot(offsetX, offsetY);
  };

  pushCoordinates = (x, y) => {
    this.setState(({ coordinates }) => ({
      coordinates: [
        ...coordinates,
        {
          x,
          y,
        },
      ],
    }));
  };

  onMouseMove = ev => {
    if (!this.isDrawing) {
      return;
    }

    const {
      offsetX: x,
      offsetY: y,
    } = ev;

    this.clearCanvas();
    this.drawCoordinates();
    const lastCoordinate = this.getLastCoordinate();
    if (lastCoordinate) {
      this.drawLine(lastCoordinate, {
        x,
        y,
      });
    }
  };

  getLastCoordinate = () => {
    const {
      coordinates,
    } = this.state;

    if (coordinates.length) {
      return coordinates[coordinates.length - 1];
    }
    return null;
  };

  drawCoordinates = () => {
    this.clearCanvas();
    const {
      coordinates,
    } = this.state;

    coordinates.forEach((coordinate, index) => {
      this.drawDot(coordinate.x, coordinate.y);
      if (index) {
        this.drawLine(coordinates[index - 1], coordinate);
      }
    });
    if (!this.isDrawing) {
      this.drawLine(coordinates[coordinates.length - 1], coordinates[0]);
    }
  };

  drawLine = (from, to) => {
    const context = this.getCanvasContext();
    if (!context) return;

    context.stroke();
    const {
      coordinates,
    } = this.state;
    if (coordinates.length) {
      context.beginPath();
      context.moveTo(from.x, from.y);
      context.lineTo(to.x, to.y);
      context.strokeStyle = '#FF3333';
      context.lineWidth = 5;
      context.stroke();
    }
  };

  drawDot = (x, y) => {
    const context = this.getCanvasContext();
    if (!context) return;
    context.beginPath();
    context.arc(x, y, 5, 0, 2 * Math.PI);
    context.strokeStyle = '#FF3333';
    context.lineWidth = 5;
    context.stroke();
    context.fillStyle = '#FF3333';
    context.fill();
  };

  render() {
    const {
      className = '',
      width,
      height,
    } = this.props;
    return (
      <canvas
        id="polygon-drawer"
        className="polygon-drawer"
        ref={this.canvasRef}
        width={width}
        height={height}
        key={width + height} // reset canvas when height, width changes
      />
    );
  }
}

export default ReactPolygonDrawer;
